import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class DateService {
    static iso8601 = /^\d{4}-\d\d-\d\dT\d\d:\d\d:\d\d(\.\d+)?(([+-]\d\d:\d\d)|Z)?$/;

    static convertToDate(body) {
        if (body === null || body === undefined) {
            return body;
        }

        if (typeof body !== 'object') {
            return body;
        }

        for (const key of Object.keys(body)) {
            const value = body[key];
            if (DateService.isIso8601(value)) {
                body[key] = new Date(value);
            } else if (typeof value === 'object') {
                this.convertToDate(value);
            }
        }
    }

    static isIso8601(value) {
        if (value === null || value === undefined) {
            return false;
        }

        return DateService.iso8601.test(value);
    }
}